import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from '@/img/icons/star.svg';

const AirHaifaPromotionBar = () => {
    const { t } = useTranslation();

    return (
        <div className="air-haifa-promotion-bar" data-testid="airhaifa-promotion-bar">
            <div className="air-haifa-promotion-bar-inner">
                <StarIcon />

                <span>
                    <span> {t('AirHaifaBanner.Description')}</span>

                    <a
                        href={"https://login.airhaifa.com/?ref_url=" + encodeURIComponent(window.location.href)}
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline' }}
                    >
                        {t('AirHaifaBanner.Login')}
                    </a>
                </span>
            </div>
        </div>
    );
};

export default AirHaifaPromotionBar;
